import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { HomePage } from '../home/home.page';
import { MenuPage } from '../menu/menu.page';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { Api } from 'src/smoothr-web-app-core/api/api';

@Component({
	selector: 'app-privacy',
	templateUrl: './privacy.page.html',
	styleUrls: ['privacy.page.scss'],
	standalone: false,
})
export class PrivacyPage {
	static url = 'privacy';
	checkIfVenueExistImpressum: string;
	constructor(
		private repository: RepositoryService,
		private router: Router
	) {}

	static async navigate(router: Router) {
		await router.navigateByUrl(PrivacyPage.url);
	}

	ionViewDidEnter() {
		if (this.repository._venue && this.repository._order) {
			if (this.repository._venue && this.repository._venue?.legal?.privacy) {
				this.checkIfVenueExistImpressum = this.repository._venue?.legal?.privacy;
			} else {
				this.checkIfVenueExistImpressum = '';
			}
		} else {
			this.checkIfVenueExistImpressum = '';
		}
		this.privacyLogic();
	}
	async privacyLogic() {
		let venue = this.repository._venue;
		try {
			if (!venue) {
				venue = await this.repository.getVenue(this.repository._order?.venue);
			}

			this.repository.venue.emit(venue);

			const response = (await Api.getLegal(venue._id)).data;
			if (response.privacy) {
				this.checkIfVenueExistImpressum = response.privacy;
			}
		} catch (err) {
			console.error('imprint error!!!!', err);
		}
	}

	goBack() {
		if (this.repository._order === null) {
			HomePage.navigate(this.router);
		} else {
			MenuPage.navigate(this.router);
		}
	}
}
